import React, { Component } from 'react';
import { connect } from 'react-redux';

import CategoryBar   from './CategoryBar.jsx';
import SortByBox   from './SortByBox.jsx';
import CategoryItems  from './CategoryItems.jsx';
import ProductDetail from './ProductDetail.jsx';
import GiftShop from './GiftShop.jsx';

class CatalogView extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    const activeFilterResult = this.props.activeFilterResult,
          activeFilter = this.props.activeFilter;
    let oCurrentView = <div></div>;
    if (this.props.activeProduct.id ){
      oCurrentView = (
        <div>
          <ProductDetail />
        </div>
      );
    }/* GIFTSHOP
      else if(activeFilter === "giftshop") {
      oCurrentView = ( <GiftShop /> );
    }*/ else {
      oCurrentView = (
        <div>
          <SortByBox
              currentCategory   = {this.props.activeFilterResult.name}
          />
          <h1>{activeFilterResult.name}</h1>
          <CategoryItems
            products                = {this.props.sortedProducts}
          />
        </div>
      );
    }

    return (
      <div className="content-max-width content-container">
        <CategoryBar />
        <div className="category-body">
          {oCurrentView}
        </div>
      </div>
    );
  }
};

CatalogView.defaultProps = {
  activeFilter: '',
  activeFilterResult: {
    products: []
  },
  categories: [],
  genres: []
};


function mapStateToProps(state){
    return {
      'path': state.path,
      'tla': state.store.tla,
      'activeFilterResult': state.activeFilterResult,
      'sortedProducts': state.sort.products,
      'activeFilter': state.activeFilter,
      'activeProduct': state.activeProduct,
      'isLoggedIn': state.isLoggedIn,
      'activeModal': state.activeModal,
      'featured' : state.featured
    };
}

export default connect(mapStateToProps)(CatalogView);



// WEBPACK FOOTER //
// ./src/components/CatalogView.jsx